import { forwardRef, HTMLInputTypeAttribute } from "react";
import FieldLabelWrapper from "./FieldLabelWrapper";
import FieldWrapper from "./FieldWrapper";
import Input from "./Input";
import FieldErrorWrapper from "./FieldErrorWrapper";
export interface FormFieldProps
  extends React.FormHTMLAttributes<HTMLFormElement | HTMLTextAreaElement> {
  submitting?: boolean;
  loading?: boolean;
  InputField?: any;
  label?: string;
  children?: any;
  type?: HTMLInputTypeAttribute;
  errorMessage?: string;
  reverse?: boolean;
  labelWrapperClassName?: string;
  inputWrapperClassName?: string;
  errorWrapperClassName?: string;
  required?: boolean;
  options?: {
    label: string;
    value: string | null;
    disabled?: boolean;
  }[];
  placeholder?: string;
  value?: string;
  maxLength?: number;
}

const FormField = (
  {
    InputField = Input,
    label,
    reverse,
    errorMessage,
    type,
    children,
    className,
    name,
    labelWrapperClassName,
    inputWrapperClassName,
    errorWrapperClassName,
    ...field
  }: FormFieldProps,
  ref,
) => {
  const inputElement = (
    <div className={inputWrapperClassName || "unchained-form-field__input"}>
      <InputField type={type} name={name} {...field} ref={ref} />
    </div>
  );

  const labelElement = (
    <FieldLabelWrapper
      name={name}
      label={label}
      className={labelWrapperClassName}
      errorMessage={errorMessage}
    >
      {errorMessage && (
        <FieldErrorWrapper
          className={errorWrapperClassName}
          name={name}
          errorMessage={errorMessage}
        />
      )}
    </FieldLabelWrapper>
  );

  return (
    <FieldWrapper
      errorMessage={errorMessage}
      className={className}
      name={name}
      type={type}
    >
      {reverse ? inputElement : labelElement}
      {reverse ? labelElement : inputElement}
      {children || undefined}
    </FieldWrapper>
  );
};

export default forwardRef(FormField);
